import { useEffect, useRef } from 'react';

// Las vistas de detalle (vino en Shop y en Cupo asignado, evento en Eventos)
// no tienen URL propia: se muestran con estado dentro de la misma ruta. Como
// el historial del navegador no se entera, el boton "atras" del celular salia
// de la pagina entera (p.ej. de /shop a /cupo-asignado) en vez de cerrar el
// detalle. Este hook empuja una entrada de historial mientras el detalle esta
// abierto y la usa para cerrarlo.
//
// Para cerrar desde la propia pagina (la flecha de volver) hay que llamar a
// window.history.back(): asi el cierre siempre pasa por popstate y no queda
// una entrada de mas en el historial.
export const useDetalleHistorial = (abierto, cerrar) => {
    const cerrarRef = useRef(cerrar);
    cerrarRef.current = cerrar;

    useEffect(() => {
        if (!abierto) return undefined;
        let cerradoPorAtras = false;
        window.history.pushState({ detalleAbierto: true }, '');
        const alVolverAtras = () => {
            cerradoPorAtras = true;
            cerrarRef.current();
        };
        window.addEventListener('popstate', alVolverAtras);
        return () => {
            window.removeEventListener('popstate', alVolverAtras);
            // Si el detalle se cerro sin usar "atras" (navbar, cambio de ruta),
            // sacamos la entrada que habiamos empujado para no dejar basura.
            if (!cerradoPorAtras && window.history.state?.detalleAbierto) {
                window.history.back();
            }
        };
    }, [abierto]);
};
